import * as React from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { Box, Button } from '@mui/material';
import { DateInput, ExportButton, useListContext } from 'react-admin';

const OrderListExportForm = () => {
    const {
        filterValues,
        setFilters,
    } = useListContext();

    const form = useForm({
        defaultValues: filterValues,
    });

    const onSubmit = (values) => {
        if (Object.keys(values).length > 0) {
            setFilters(values);
        }
    };

    const resetFilter = () => {
        setFilters({}, []);
    };

    return (
        <FormProvider {...form} initialValues={filterValues}>
            <form onSubmit={form.handleSubmit(onSubmit)}>
                <Box display="flex" justifyContent="space-between" width="100%">
                    <Box display="flex" alignItems="flex-start" mb={0} mt={0}>
                        <Box component="span" mr={2} mb={0} mt={0}>
                            <DateInput
                                resettable
                                helperText={false}
                                source="sd"
                                label="Start Date"
                            />
                        </Box>
                        <Box component="span" mr={2} mb={0} mt={0}>
                            <DateInput
                                resettable
                                helperText={false}
                                source="ed"
                                label="End Date"
                            />
                        </Box>
                    </Box>
                    <Box display="flex" alignItems="flex-end" mb={0} mt={0}>
                        <Box component="span" mr={2} mb={1.5}>
                            <Button variant="outlined" color="primary" type="submit">
                            Filter
                            </Button>
                        </Box>
                        <Box component="span" mr={2} mb={1.5}>
                            <Button variant="outlined" onClick={resetFilter}>
                            Clear
                            </Button>
                        </Box>
                        <Box component="span" mb={1.5}>
                            <ExportButton maxResults={100000} />
                        </Box>
                    </Box>
                </Box>
            </form>
        </FormProvider>
    );
};

export default OrderListExportForm;
